import styled from "styled-components";

const Subhead = styled.h2``;

export default Subhead;



// WEBPACK FOOTER //
// ./components/Subhead.jsx